<template>
  <div id="app" class="d-flex flex-column">
    <navbar/>
    <div class="d-flex flex-column flex-grow-1">
      <breadcrumbs :route="$route" />
      <router-view/>
      <div class="flex-grow-1"></div>
      <img :alt="$t('site_title')" aria-hidden="true" class="d-block footer-image" src="./assets/img/bg-img-footer.svg"/>
      <footer-bar></footer-bar>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import FooterBar from './components/FooterBar'
import Breadcrumbs from './components/Breadcrumbs'

export default {
  components: { Breadcrumbs, FooterBar, Navbar },
  methods: {
    setTitle ({ path, name }) {
      if (path === '/') {
        document.title = this.$t('site_title')
      } else {
        document.title = this.$t('subpage_title', { title: this.$t(name + '.title') })
      }
    },
    async checkLogin () {
      if (!this.$store.getters['user/loggedIn']) return

      try {
        await this.$api.user.getUser({ id: this.$store.getters['user/data'].id })
      } catch (e) {
        this.$store.dispatch('user/saveData', null)
        this.$router.replace('/login')
      }
    }
  },
  watch: {
    $route () {
      this.setTitle(this.$route)
    }
  },
  mounted () {
    this.setTitle(this.$route)
    this.checkLogin()
  }
}
</script>

<style lang="scss" scoped>
  #app {
    min-height: 100vh;
  }
  img.footer-image {
    width: 100%;
    height: auto;
  }
</style>
